import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Map",
            key: "map",
            icon: <Icon fontSize="medium">map</Icon>,
            route: "/map/home",
            privacy: "private",
        },
    ];
};

export default menus;